import { motion } from "framer-motion";

export const Reveal = ({ children, delay = 0, className = "", y = 30 }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-70px" }}
    transition={{ duration: 0.9, delay, ease: [0.16, 1, 0.3, 1] }}
  >
    {children}
  </motion.div>
);

export const MaskedLine = ({ children, delay = 0, className = "" }) => (
  <span className={`block overflow-hidden ${className}`}>
    <motion.span
      className="block"
      initial={{ y: "112%" }}
      animate={{ y: "0%" }}
      transition={{ duration: 1.15, delay, ease: [0.16, 1, 0.3, 1] }}
    >
      {children}
    </motion.span>
  </span>
);

export const FrequencyWave = ({ className = "", opacity = 1, tone = "dark" }) => {
  const silver = tone === "dark" ? "rgba(22,19,14,0.3)" : "rgba(209,213,219,0.35)";
  const gold = tone === "dark" ? "rgba(184,145,46,0.55)" : "rgba(212,175,55,0.55)";
  const champagne = tone === "dark" ? "rgba(138,109,31,0.25)" : "rgba(243,229,171,0.28)";
  return (
    <svg
      className={className}
      viewBox="0 0 1440 220"
      fill="none"
      preserveAspectRatio="none"
      aria-hidden="true"
      style={{ opacity }}
    >
      <path
        className="wave-line-slow"
        d="M0 110 C 120 40, 240 40, 360 110 S 600 180, 720 110 S 960 40, 1080 110 S 1320 180, 1440 110"
        stroke={silver}
        strokeWidth="1"
      />
      <path
        className="wave-line"
        d="M0 110 C 120 60, 240 60, 360 110 S 600 160, 720 110 S 960 60, 1080 110 S 1320 160, 1440 110"
        stroke={gold}
        strokeWidth="1.2"
      />
      <path
        className="wave-line-slow"
        d="M0 110 C 180 90, 300 90, 420 110 S 660 130, 780 110 S 1020 90, 1140 110 S 1350 128, 1440 110"
        stroke={champagne}
        strokeWidth="0.8"
      />
    </svg>
  );
};
